import React from "react";

function SectionHeading({ title, className }) {
  return (
    <div
      className={`flex flex-col items-center justify-center w-full ${className}`}
    >
      <h2 className="text-[36px] md:text-[44px] font-bold text-center text-[#050426] tracking-[0.36px] md:tracking-[0.44px] leading-[43.2px] md:leading-[52.8px]">
        {title}
      </h2>
      <div className="mt-[14px] w-[2rem] h-1 bg-[#E81E61] rounded-full"></div>
    </div>
  );
}

export default SectionHeading;
